import { render } from "./FishAviso.vue?vue&type=template&id=7681bb22&scoped=true"
import script from "./FishAviso.vue?vue&type=script&lang=js"
export * from "./FishAviso.vue?vue&type=script&lang=js"

import "./FishAviso.vue?vue&type=style&index=0&id=7681bb22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7681bb22"]])

export default __exports__